import React, { useState } from "react";
import { Route, Redirect, Link } from "react-router-dom";
import { isLogin } from "../utils/AuthGuard";
import HeaderComponent from "./HeaderComponent";
import logo from "../assets/images/logo-payap.png";
import { logout } from "../utils/AuthGuard";
import { Radio, Row, Col, Affix, Button } from "antd";

const InfoRoute = ({ component: Component,data:data,...rest }) => {
  const [language, setLanguage] = useState(localStorage.getItem('Language'));

  function handleLogout() {
    localStorage.clear();
    localStorage.setItem("Language", "TH");
    logout();
  }
//  console.log('component',Component)
  
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page

    <Route
      {...rest}
      render={(props) =>
        isLogin() ? (
          <div>
            <Affix offsetTop={0}>
              <div style={{ backgroundColor: "#018FD6", padding: 10 }}>
                <Row>
                  <Col style={{ padding: "10px 0", marginLeft: 15 }}>
                    <Link to="/home"> 
                      <img src={logo} alt="Logo" />
                    </Link>
                  </Col>
                  <Col
                    span={12}
                    style={{ marginLeft: 15, color: "#fff", fontSize: 16 }}
                  >
                    <p>
                      สำนักทรัพยากรบุคคล <br /> Office of Human Resources
                    </p>
                  </Col>

                  <p style={{ color: "#fff", fontSize: 16, padding: "10px 0" }}>
                    เลือกภาษา
                  </p>
                  <div style={{ padding: "10px 0", marginLeft: 15 }}>
                    <Radio.Group
                      defaultValue={localStorage.getItem("Language")}
                      buttonStyle="solid"
                    >
                      <Radio.Button
                        value="TH"
                        onClick={() => [setLanguage("TH"),localStorage.setItem('Language','TH')]}
                      >
                        ไทย
                      </Radio.Button>
                      <Radio.Button
                        value="EN"
                        onClick={() => [setLanguage("EN"),localStorage.setItem('Language','EN')]}
                      >
                        English
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div style={{ padding: "10px 0", marginLeft: 15 }}>
                    <Button onClick={() => handleLogout()}>
                      {language == "TH" ? (
                        <Link to="/"> ออกจากระบบ </Link>
                      ) : (
                        <Link to="/"> Sign Out </Link>
                      )}
                    </Button>
                  </div>
                </Row>
              </div>
            </Affix>
            <Component lang={language} {...props} /> 
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default InfoRoute;
